export default __webpack_public_path__ + "static/media/1925.480f0cf5.png";